import * as y from "yup"
import {ComponentBase, ContentCardID, baseSchema} from "./base"

export interface Popup extends ComponentBase {
  subtitle?: string
  icon: string
  message?: string
  ctaCopy: string
  ctaUrl: string
  ctaUrlExternal: boolean
  title: string
  headerIcon?: string

  /**
   * Subsequent component to render when this notification is clicked
   */
  linkedComponent?: ContentCardID
}

export const PopupSchema = y.object<Popup>({
  ...baseSchema,
  title: y.string().required(),
  icon: y.string().required(),
  subtitle: y.string().required(),
  ctaCopy: y.string().required(),
  message: y.string(),
  ctaUrl: y.string().required(),
  ctaUrlExternal: y.boolean().default(false),
  headerIcon: y.string()
})
